import React from "react";
import { Route, Routes } from "react-router-dom";
import JobOpening from "../Pages/JobOpeningView/JobOpening";
import PageOpening from "../Pages/JobOpeningView/PageOpening";
import ApplyJobOpen from "../Pages/ApplyJobOpening/ApplyJobOpen";
import Dashboard from "../Pages/Dashboard/Dashboard";
import StepperForm from "../Pages/WorkflowStepperForm/StepperForm";
import CandidateOtherDetails from "../Pages/CandidateDetails/CandidateOtherDetails";
import CandidateCabinet from "../Pages/CandidateCabinet/CandidateCabinet";
import Notifications from "../Pages/Notifications/Notifications";

const Content = (props) => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Dashboard />} />

        <Route
          path={`/:title`}
          element={<PageOpening loginHandler={props.loginHandler} />}
        />

        <Route path={`/apply/:title`} element={<ApplyJobOpen />} />

        <Route path={`/jobopening`} element={<JobOpening />} />

        <Route
          path={`/candidateotherdetails`}
          element={<CandidateOtherDetails />}
        />

        {/* STEPPER */}
        <Route path="/stepper" element={<StepperForm />} />

        <Route path={`/cabinet`} element={<CandidateCabinet />} />
        <Route path={`/candidatecabinet`} element={<StepperForm />} />

        {/* Notification */}
        <Route path="/tickets" element={<Notifications />} />

      </Routes>
    </>
  );
};

export default Content;
